<template>
  <div>
    <NavBar msg="交易"></NavBar>
    <div class="content">
      <van-tabs v-model="active" @click="onClick">
        <van-tab title="买入">
          <div class="main">
            <div class="left">
              <div class="stockIpt">
                <img src="../assets/MairuIcSousuo@2x.png" alt="" />
                <van-field v-model="buyStkCode" @input="stockCodeIput" placeholder="请输入股票代码" />
                <span v-if="buyStkName != ''">{{ buyStkName }}</span>
              </div>
              <div class="stockPrice stockAdd">
                <div class="jian" @click="buypriceSubClick">
                  <p></p>
                </div>
                <div class="ipt">
                  <input type="text" v-model="buyprice" @input="buyPriceIput" placeholder="买入价格" />
                </div>
                <p class="add" @click="buypriceAddClick">+</p>
              </div>
              <div class="stockInterval">
                <div @click="downClick(info.down_px)">
                  跌停 {{ info.down_px ? " " + info.down_px : " --" }}
                </div>
                <div @click="upClick(info.up_px)">
                  涨停 {{ info.up_px ? " " + info.up_px : " --" }}
                </div>
              </div>
              <div class="stockNum stockAdd">
                <div class="jian" @click="buysumSubClick">
                  <p></p>
                </div>
                <div class="ipt">
                  <input type="text" v-model="buysum" @input="buysumIput" placeholder="买入数量" />
                </div>
                <p class="add" @click="buysumAddClick">+</p>
              </div>
              <div class="stockInterval">
                <p>
                  可买<span style="color: rgba(236, 51, 59, 1)">{{
                    buyable
                  }}</span>股
                </p>
                <p class="buyAmount" v-if="Amount != '' && Amount > 0">
                  {{ Amount }}
                </p>
              </div>

              <div class="stockList">
                <van-tag color="#F3F4F6" text-color="#48546A" @click="allClick()">全仓</van-tag><van-tag color="#F3F4F6"
                  text-color="#48546A" @click="halfClick()">半仓</van-tag><van-tag color="#F3F4F6" text-color="#48546A"
                  @click="thirdClick()">1/3仓</van-tag><van-tag color="#F3F4F6" text-color="#48546A"
                  @click="quarterClick()">1/4仓</van-tag>
              </div>
              <van-button color=" rgba(236, 51, 59, 1) " @click="buyClick()" :disabled="disabled">买入</van-button>
            </div>
            <div class="right">
              <Right :info="info" @priceClick="priceClick"></Right>
            </div>
          </div>
          <div style="margin-top: 0.2rem">
            <div class="main-centent">
              <div class="todaySelected-title">
                <div style="width: 1.95rem">股票/市值</div>
                <div style="width: 1.93rem">盈亏</div>
                <div style="width: 1.3rem">持仓/可用</div>
                <div style="width: 1.65rem; text-align: right" @click="zfClick()">
                  <span>成本/现价</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="stockList.length > 0">
            <Chicang :list="stockList" @parentEvent="toClick"></Chicang>
          </div>
          <div v-else class="wushuju" v-show="stockShow">
            <img src="../assets/wushuju.png" alt="" />
            <p>暂无数据</p>
          </div>
        </van-tab>
        <van-tab title="卖出">
          <div class="main">
            <div class="left">
              <div class="stockIpt">
                <img src="../assets/MairuIcSousuo@2x.png" alt="" />
                <input type="text" v-model="sellStkCode" @input="sellCodeIput" placeholder="请输入股票代码" />
                <span v-if="sellStkName != ''">{{ sellStkName }}</span>
              </div>
              <div class="stockPrice stockAdd">
                <div class="jian" @click="sellpriceSubClick">
                  <p></p>
                </div>
                <div class="ipt">
                  <input type="text" v-model="sellprice" @input="sellPriceIput" placeholder="卖出价格" />
                </div>
                <p class="selladd" @click="sellpriceAddClick">+</p>
              </div>
              <div class="stockInterval">
                <div @click="selldownClick(sellInfo.down_px)">
                  跌停 {{ sellInfo.down_px ? " " + sellInfo.down_px : " --" }}
                </div>
                <div @click="sellupClick(sellInfo.up_px)">
                  涨停 {{ sellInfo.up_px ? " " + sellInfo.up_px : " --" }}
                </div>
              </div>
              <div class="stockNum stockAdd">
                <div class="jian" @click="sellsumSubClick">
                  <p></p>
                </div>
                <div class="ipt">
                  <input type="text" v-model="sellsum" @input="sellsumIput" placeholder="卖出数量" />
                </div>
                <p class="selladd" @click="sellsumAddClick">+</p>
              </div>
              <div class="stockInterval">
                <p>
                  可卖<span style="color: rgba(236, 51, 59, 1)">{{
                    sellable
                  }}</span>股
                </p>
                <p class="sellAmount" v-if="sellAmount != '' && sellAmount > 0">
                  {{ sellAmount }}
                </p>
              </div>

              <div class="stockList">
                <van-tag color="#F3F4F6" text-color="#48546A" @click="sellallClick()">全仓</van-tag><van-tag color="#F3F4F6"
                  text-color="#48546A" @click="sellhalfClick()">半仓</van-tag><van-tag color="#F3F4F6" text-color="#48546A"
                  @click="sellthirdClick()">1/3仓</van-tag><van-tag color="#F3F4F6" text-color="#48546A"
                  @click="sellquarterClick()">1/4仓</van-tag>
              </div>
              <van-button color="rgba(50, 131, 234, 1)" @click="sellClick()" :disabled="selldisabled">卖出</van-button>
            </div>
            <div class="right">
              <Right :info="sellInfo" @priceClick="sellpriceClick"></Right>
            </div>
          </div>
          <div style="margin-top: 0.2rem">
            <div class="main-centent">
              <div class="todaySelected-title">
                <div style="width: 1.95rem">股票/市值</div>
                <div style="width: 1.93rem">盈亏</div>
                <div style="width: 1.3rem">持仓/可用</div>
                <div style="width: 1.65rem; text-align: right" @click="zfClick()">
                  <span>成本/现价</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="stockList.length > 0">
            <Chicang :list="stockList" @parentEvent="selltoClick"></Chicang>
          </div>
          <div v-else class="wushuju" v-show="stockShow">
            <img src="../assets/wushuju.png" alt="" />
            <p>暂无数据</p>
          </div>
        </van-tab>
        <van-tab title="查询">
          <ul class="list">
            <li @click="goJRCJ()">
              <span>当日成交</span><img src="../assets/more.png" alt="" />
            </li>
            <li @click="goJRWT()">
              <span>当日委托</span><img src="../assets/more.png" alt="" />
            </li>
            <li @click="goLSCJ()">
              <span>历史成交</span><img src="../assets/more.png" alt="" />
            </li>
            <li @click="goLSWT()">
              <span>历史委托</span><img src="../assets/more.png" alt="" />
            </li>
          </ul>
        </van-tab>
      </van-tabs>
      <div class="StockCodeList">
        <van-overlay :show="show" @click="show = false">
          <div class="wrapper" @click.stop>
            <div class="block">
              <div>
                <p v-for="(item, index) in sList" :key="index" @click="itemStockClick(item)">
                  <span>{{ item.prodName }}</span>
                  <span>{{ item.prodCode.split(".")[0] }}</span>
                  <span>{{ item.nameChispel }}</span>
                </p>
              </div>
            </div>
          </div>
        </van-overlay>
      </div>
      <div class="Btnshow">
        <van-overlay :show="Btnshow">
          <div class="wrapper" @click.stop>
            <div class="block">
              <p class="btn-title">委托{{ btnMsg.name }}确认</p>
              <div class="btn-info">
                <p>
                  <span>名称</span><span>{{ btnMsg.StkName }}</span>
                </p>
                <p>
                  <span>代码</span><span style="padding-top: 0.02rem">{{
                    btnMsg.StkCode
                  }}</span>
                </p>
                <p>
                  <span>数量</span><span style="color: #ec333b; padding-top: 0.02rem">{{
                    btnMsg.sum
                  }}</span>
                </p>
                <p>
                  <span>价格</span><span style="color: #ec333b; padding-top: 0.02rem">{{
                    btnMsg.price
                  }}</span>
                </p>
              </div>
              <div style="font-size: 0.28rem; padding-left: 0.2rem">
                您是否确认以上委托?
              </div>
              <div class="btn">
                <div class="btn-left" @click="Btnshow = false">取消</div>
                <div class="btn-right" style="color: #ec333b" @click="OkBtn()" v-preventReClick>
                  确认{{ btnMsg.name }}
                </div>
              </div>
            </div>
          </div>
        </van-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Chicang from "@/components/chicang1.vue";
import Right from "@/components/dealright.vue";
import { changeBillionToCN } from "@/utils/num";
import preventReClick from "@/utils/num";
import api from "@/api/index";
import zfxfApi from "@/api/trading_zfxf";

import { Tab, Tabs, Toast, Tag, Button, Field, Overlay } from "vant";
export default {
  components: {
    Chicang,
    NavBar,
    Right,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Field.name]: Field,
    [Overlay.name]: Overlay,
  },
  data() {
    return {
      active: 0,
      stockList: [],
      stkCode: "",
      buyStkName: "",
      buyStkCode: "",
      buyprice: "",
      buysum: "",
      buymarket: "",
      sellStkCode: "",
      sellStkName: "",
      sellprice: "",
      sellsum: "",
      sellable: 0,
      sellmarket: "",
      info: {},
      sellInfo: {},
      balance: 0,
      buyable: 0,
      Amount: "",
      sellAmount: "",
      sList: [],
      show: false,
      buyBtn: "0",
      disabled: true,
      selldisabled: true,
      sellCode: "",
      buyCode: "",
      Btnshow: false,
      btnMsg: {},
      userId: "",
      stockShow: false,
      upLoadClicktag: 0,
    };
  },
  created() {
    this.userId = localStorage.getItem("userId");

    var active = this.$route.query.id;
    this.active = parseInt(active);
    this.getFund();
    this.getlist();

    var market = this.$route.query.market;
    var stkCode = this.$route.query.stkCode;
    var stkBalanceSum = this.$route.query.stkBalanceSum;
    if (stkCode) {
      let code = stkCode + "." + market;
      if (active == 1) {
        this.sellCode = code;
        this.sellReal(code);
        this.sellmarket = market;
        this.sellStkCode = stkCode;
        this.sellable = stkBalanceSum;
        this.Amount = "";
      } else {
        this.buyCode = code;
        this.getReal(code);
        this.buyStkCode = stkCode;
        this.buysum = "";
        this.Amount = "";
        this.buymarket = market;

        this.buyBtnChange();
      }
    }
  },
  watch: {
    stockList() {
      this.timer();
    },
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    timer() {
      return setTimeout(() => {
        this.getlist();
        if (this.buyCode != "" && this.active == 0 && this.buyStkCode != "") {
          this.rightReal(this.active, this.buyCode);
        } else if (
          this.sellCode != "" &&
          this.active == 1 &&
          this.sellStkCode != ""
        ) {
          this.rightReal(this.active, this.sellCode);
        }
      }, 10000);
    },
    rightReal(active, stockCode) {
      let params = { prodCode: stockCode };
      zfxfApi.getStockReal(params).then((res) => {
        // console.log(res);
        if (res.code == 0) {
          var data = res.data[Object.keys(res.data)[0]];
          data.sellVolume1 = changeBillionToCN(data.sellVolume1);
          data.sellVolume2 = changeBillionToCN(data.sellVolume2);
          data.sellVolume3 = changeBillionToCN(data.sellVolume3);
          data.sellVolume4 = changeBillionToCN(data.sellVolume4);
          data.sellVolume5 = changeBillionToCN(data.sellVolume5);
          data.buyVolume1 = changeBillionToCN(data.buyVolume1);
          data.buyVolume2 = changeBillionToCN(data.buyVolume2);
          data.buyVolume3 = changeBillionToCN(data.buyVolume3);
          data.buyVolume4 = changeBillionToCN(data.buyVolume4);
          data.buyVolume5 = changeBillionToCN(data.buyVolume5);
          if (active == 0) {
            this.info = data;
          } else {
            this.sellInfo = data;
          }
        } else if (res.code == 401) {
          setTimeout(() => {
            this.rightReal(active, stockCode);
          }, 500);
        }
      });
    },
    allClick() {
      // console.log();
      if (this.buyable >= 100) {
        this.buysum = this.buyable;
        this.Amount = (this.buysum * this.buyprice).toFixed(2);
        this.buyBtnChange();
      }
    },
    halfClick() {
      if (this.buyable >= 100) {
        this.buysum = parseInt(this.buyable / 2 / 100) * 100;
        if (this.buysum < 100) {
          this.buysum = 100;
        }
        this.Amount = (this.buysum * this.buyprice).toFixed(2);
        this.buyBtnChange();
      }
    },
    thirdClick() {
      if (this.buyable >= 100) {
        this.buysum = parseInt(this.buyable / 3 / 100) * 100;
        if (this.buysum < 100) {
          this.buysum = 100;
        }
        this.Amount = (this.buysum * this.buyprice).toFixed(2);
        this.buyBtnChange();
      }
    },
    quarterClick() {
      if (this.buyable >= 100) {
        this.buysum = parseInt(this.buyable / 4 / 100) * 100;
        if (this.buysum < 100) {
          this.buysum = 100;
        }
        this.Amount = (this.buysum * this.buyprice).toFixed(2);
        this.buyBtnChange();
      }
    },
    toClick(msg) {
      // console.log(msg);
      this.buyCode = msg.stkCode + "." + msg.market;
      this.getReal(this.buyCode);
      this.buyStkCode = msg.stkCode;
      this.buymarket = msg.market;
      this.buysum = "";
      this.Amount = "";
      this.buyBtnChange();
    },
    selltoClick(msg) {
      // console.log(msg);
      this.sellCode = msg.stkCode + "." + msg.market;
      this.sellReal(this.sellCode);
      this.sellStkCode = msg.stkCode;
      this.sellable = msg.stkBalanceSum;
      this.sellmarket = msg.market;
      this.Amount = "";
      this.buyBtnChange();
    },
    buyPriceIput() {
      this.buysum = this.buyable;
      this.Amount = (this.buysum * this.buyprice).toFixed(2);
      this.buyBtnChange();
    },
    buysumIput() {
      this.Amount = (this.buysum * this.buyprice).toFixed(2);
      this.buyBtnChange();
    },
    downClick(value) {
      this.buyprice = value;
      this.Amount = (this.buysum * this.buyprice).toFixed(2);
      this.buyBtnChange();
    },
    upClick(value) {
      this.buyprice = value;
      this.Amount = (this.buysum * this.buyprice).toFixed(2);
      this.buyBtnChange();
    },
    buypriceAddClick() {
      if (Number(this.buyprice) < Number(this.info.up_px)) {
        this.buyprice = (Number(this.buyprice) + 0.01).toFixed(2);
        this.Amount = (this.buysum * this.buyprice).toFixed(2);
        this.buyBtnChange();
      }
    },
    buypriceSubClick() {
      if (Number(this.buyprice) > Number(this.info.down_px)) {
        this.buyprice = (Number(this.buyprice) - 0.01).toFixed(2);
        this.Amount = (this.buysum * this.buyprice).toFixed(2);
      } else {
        this.info.down_px;
      }
      this.buyBtnChange();
    },
    buysumSubClick() {
      if (this.buysum >= 200 && this.buysum <= this.buyable) {
        this.buysum = Number(this.buysum) - 100;
      } else if (this.buysum > this.buyable) {
        this.buysum = this.buyable;
      }
      this.Amount = (this.buysum * this.buyprice).toFixed(2);
      this.buyBtnChange();
    },
    buysumAddClick() {
      if (this.buysum < this.buyable) {
        this.buysum = Number(this.buysum) + 100;
      } else if (this.buysum > this.buyable) {
        this.buysum = this.buyable;
      }
      this.Amount = (this.buysum * this.buyprice).toFixed(2);
      this.buyBtnChange();
    },
    priceClick(msg) {
      // console.log(msg);
      this.buyprice = msg;
      this.Amount = (this.buysum * this.buyprice).toFixed(2);
      this.buyBtnChange();
    },
    sellpriceClick(msg) {
      // console.log(msg);
      this.sellprice = msg;
      this.sellAmount = (this.sellsum * this.sellprice).toFixed(2);
      this.sellBtnChange();
    },
    getReal(stockCode) {
      // console.log(1111);
      let params = { prodCode: stockCode };
      zfxfApi.getStockReal(params).then((res) => {
        // console.log(res);
        if (res.code == 0) {
          var data = res.data[Object.keys(res.data)[0]];
          data.sellVolume1 = changeBillionToCN(data.sellVolume1);
          data.sellVolume2 = changeBillionToCN(data.sellVolume2);
          data.sellVolume3 = changeBillionToCN(data.sellVolume3);
          data.sellVolume4 = changeBillionToCN(data.sellVolume4);
          data.sellVolume5 = changeBillionToCN(data.sellVolume5);
          data.buyVolume1 = changeBillionToCN(data.buyVolume1);
          data.buyVolume2 = changeBillionToCN(data.buyVolume2);
          data.buyVolume3 = changeBillionToCN(data.buyVolume3);
          data.buyVolume4 = changeBillionToCN(data.buyVolume4);
          data.buyVolume5 = changeBillionToCN(data.buyVolume5);

          this.info = data;
          // this.buyStkCode = stockCode;
          this.buyStkName = this.info.prod_name;
          if (this.info.sellPrice1 != 0) {
            this.buyprice = this.info.sellPrice1;
          } else if (this.info.buyPrice1 != 0) {
            this.buyprice = this.info.buyPrice1;
          } else if (this.info.last_px != 0) {
            this.buyprice = this.info.last_px;
          } else if (this.info.last_px != 0) {
            this.buyprice = this.info.last_px;
          } else if (this.info.down_px != 0) {
            this.buyprice = this.info.down_px;
          }

          if (this.balance == 0) {
            api
              .getFund({ analog_stock_account_id: this.userId })
              .then((res) => {
                // console.log(res);
                if (res.code == 200) {
                  this.balance = res.data.balance;
                  if (this.buyprice != 0) {
                    this.buyable =
                      parseInt(
                        this.balance / (1 + 0.0004) / this.buyprice / 100
                      ) * 100;
                  } else {
                    this.buyable = 0;
                  }
                  // console.log(this.buyable);
                  if (this.buyable == NaN) {
                    this.buyable = 0;
                  }
                }
              });
          } else {
            if (this.buyprice != 0) {
              this.buyable =
                parseInt(this.balance / (1 + 0.0004) / this.buyprice / 100) *
                100;
            } else {
              this.buyable = 0;
            }
          }

          this.show = false;
        } else if (res.code == 401) {
          setTimeout(() => {
            this.getReal(stockCode);
          }, 500);
        }
      });
    },
    buyClick() {
      // 买入

      this.btnMsg = {
        price: this.buyprice,
        StkCode: this.buyStkCode,
        StkName: this.buyStkName,
        sum: this.buysum,
        market: this.buymarket,
        Type: 1,
        name: "买入",
      };
      this.Btnshow = true;
    },
    OkBtn() {
      this.Btnshow = false;
      if (this.upLoadClicktag == 0) {
        //改版变量
        this.upLoadClicktag = 1;
        this.creorder(
          this.btnMsg.price,
          this.btnMsg.sum,
          this.btnMsg.Type,
          this.btnMsg.StkCode,
          this.btnMsg.market
        );
        // console.log(this.btnMsg);
        setTimeout(() => {
          this.upLoadClicktag = 0;
        }, 2000);
      }
    },
    creorder(price, sum, Type, StkCode, market) {
      // 下单
      let params = {
        analog_stock_account_id: this.userId,
        inout: Type,
        orderNum: sum,
        orderPrice: price,
        orderType: 0,
        stockCode: StkCode,
        market: market,
      };
      api.getCreorder(params).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          Toast("下单成功");
          this.getFund();

          if (Type == 2) {
            this.sellInfo = {};
            this.sellprice = "";
            this.sellStkName = "";
            this.sellStkCode = "";
            this.sellable = 0;
            this.sellsum = "";
            this.sellAmount = "";
          } else {
            this.info = {};
            this.buyprice = "";
            this.buyStkName = "";
            this.buyStkCode = "";
            this.buyable = 0;
            this.buysum = "";
            this.Amount = "";
          }
        } else {
          Toast(res.message);
          this.Btnshow = false;
        }
      });
    },

    getlist() {
      // 获取持仓列表
      api
        .getStockShares({ analog_stock_account_id: this.userId })
        .then((res) => {
          // console.log(res);

          if (res.code == 200) {
            res.data.totalProfit = (
              Number(res.data.sharesValue) +
              Number(res.data.frozenMoney) +
              Number(res.data.balance) -
              Number(res.data.initMoney)
            ).toFixed(2);
            this.stockList = res.data;
            if (this.stockList.length > 0) {
              this.stockShow = false;
            } else {
              this.stockShow = true;
            }
          }
        });
    },
    getFund() {
      // 查询余额
      api.getFund({ analog_stock_account_id: this.userId }).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.balance = res.data.balance;
          // console.log(this.balance);
        }
      });
    },

    buyBtnChange() {
      // 监测输入框变化  改变买入按钮是否可用
      if (
        this.buyStkCode != "" &&
        this.buyprice != "" &&
        Number(this.buyprice) <= Number(this.info.up_px) &&
        Number(this.buyprice) >= Number(this.info.down_px) &&
        this.buysum >= 100 &&
        this.buysum <= this.buyable
      ) {
        this.disabled = false;
      } else if (
        this.buyStkCode != "" &&
        this.buyprice != "" &&
        Number(this.info.up_px) == 0 &&
        Number(this.info.down_px) == 0 &&
        this.buysum >= 100 &&
        this.buysum <= this.buyable
      ) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },

    stockCodeIput() {
      // 买入搜索框
      // console.log(this.buyStkCode);
      if (this.buyStkCode == "") {
        this.show = false;
        this.sList = [];
        this.info = {};
        this.buyprice = "";
        this.buyStkName = "";
        this.buyable = 0;
        this.buysum = "";
        this.Amount = "";
        this.buyStkCode = "";
        this.buyCode = "";
        return;
      }
      if (this.buyStkCode != "") {
        this.getSearchstock(this.buyStkCode, 0);
      }
    },

    itemStockClick(item) {
      // 股票搜索列表点击
      var id = this.$route.query.id;
      // console.log(item);

      if (id == 0) {
        this.buyStkCode = item.prodCode.split(".")[0];
        this.show = false;
        this.buyCode = item.prodCode;
        this.buymarket = item.prodCode.split(".")[1];
        this.getReal(item.prodCode);
      } else if (id == 1) {
        this.sellCode = item.prodCode;
        this.sellStkCode = item.prodCode.split(".")[0];
        this.show = false;
        this.sellmarket = item.prodCode.split(".")[1];
        this.sellReal(item.prodCode);
      }
    },

     getSearchstock(StkCode, type) {
      // 股票查询
      if (StkCode == "") {
        this.show = false;
        return;
      }
      let params = { stockCode: StkCode, page: 1, pageSize: 10 };
       zfxfApi.getSearchstock(params).then((res) => {
        if (res.code == 0 || res.code == 200) {
          if(this.active == 0&&this.buyStkCode!=res.data.stockCode){
            return false
          }
          if(this.active == 1&&this.sellStkCode!=res.data.stockCode){
            return false
          }
          this.sList = res.data.result;
          // 处理接口慢的问题
         
          if (this.sList.length == 1) {
            var code = this.sList[0].prodCode.split(".")[0];
            // console.log(code, StkCode);
            if (code == StkCode) {
              this.show = false;
              if (type == 0 && this.buyStkCode != "") {
                this.buyCode = this.sList[0].prodCode;
                this.buymarket = this.sList[0].prodCode.split(".")[1];
                this.getReal(this.sList[0].prodCode); //查询股票10档买卖
              } else if (type == 1 && this.sellStkCode != "") {
                this.sellCode = this.sList[0].prodCode;
                this.sellmarket = this.sList[0].prodCode.split(".")[1];
                this.sellReal(this.sList[0].prodCode);
              }
            } else {
              this.show = true;
            }
          } else if (this.sList.length > 0 && StkCode != "") {
            this.show = true;
          }
          if (this.active == 0) {
            if (this.sList.length > 0 && this.buyStkCode == "") {
              this.show = false;
            }
          } else if (this.active == 1) {
            if (this.sList.length > 0 && this.sellStkCode == "") {
              this.show = false;
            }
          }
        } else if (res.code == 401) {
          setTimeout(() => {
            this.getSearchstock(stockCode, StkCode);
          }, 500);
        }
      });
    },

    sellBtnChange() {
      // 监测输入框变化  改变买入按钮是否可用
      console.log(this.sellStkCode);
      console.log(this.sellprice);
      console.log(this.sellsum >= 100);
      console.log(Number(this.sellsum), Number(this.sellable));
      console.log(Number(this.sellsum) <= Number(this.sellable));
      if (
        this.sellStkCode != "" &&
        this.sellprice != "" &&
        Number(this.sellprice) <= Number(this.sellInfo.up_px) &&
        Number(this.sellprice) >= Number(this.sellInfo.down_px) &&
        Number(this.sellsum) >= 100 &&
        Number(this.sellsum) <= Number(this.sellable)
      ) {
        console.log(111);
        this.selldisabled = false;
      } else if (
        this.sellStkCode != "" &&
        this.sellprice != "" &&
        Number(this.sellInfo.up_px) == 0 &&
        Number(this.sellInfo.down_px) == 0 &&
        Number(this.sellsum) >= 100 &&
        Number(this.sellsum) <= Number(this.sellable)
      ) {
        console.log(222);
        this.selldisabled = false;
      } else {
        console.log(333);
        this.selldisabled = true;
      }
    },
    sellpriceAddClick() {
      if (Number(this.sellprice) < Number(this.sellInfo.up_px)) {
        this.sellprice = (Number(this.sellprice) + 0.01).toFixed(2);
        this.sellAmount = (this.sellsum * this.sellprice).toFixed(2);
        this.sellBtnChange();
      } else {
        this.sellprice = this.sellInfo.up_px;
      }
    },
    sellpriceSubClick() {
      if (Number(this.sellprice) > Number(this.sellInfo.down_px)) {
        this.sellprice = (Number(this.sellprice) - 0.01).toFixed(2);
        this.sellAmount = (this.sellsum * this.sellprice).toFixed(2);
      } else {
        this.sellprice = this.sellInfo.down_px;
      }
      this.sellBtnChange();
    },
    sellsumSubClick() {
      console.log(this.sellsum);
      if (
        Number(this.sellsum) >= 200 &&
        Number(this.sellsum) <= Number(this.sellable)
      ) {
        this.sellsum = Number(this.sellsum) - 100;
      } else if (Number(this.sellsum) > Number(this.sellable)) {
        this.sellsum = this.sellable;
      }
      this.sellAmount = (this.sellsum * this.sellprice).toFixed(2);
      this.sellBtnChange();
    },
    sellsumAddClick() {
      // console.log(this.sellable);
      if (this.sellable == 0) {
        return;
      }
      if (this.sellsum < this.sellable) {
        this.sellsum = Number(this.sellsum) + 100;
      } else if (this.sellsum > this.sellable) {
        this.sellsum = this.sellable;
      }
      this.sellAmount = (this.sellsum * this.sellprice).toFixed(2);
      this.sellBtnChange();
    },
    selldownClick(value) {
      this.sellprice = value;
      this.sellAmount = (this.sellsum * this.sellprice).toFixed(2);
      this.sellBtnChange();
    },
    sellupClick(value) {
      this.sellprice = value;
      this.sellAmount = (this.sellsum * this.sellprice).toFixed(2);
      this.sellBtnChange();
    },
    sellallClick() {
      if (this.sellable >= 100) {
        this.sellsum = this.sellable;
        this.sellAmount = (this.sellsum * this.sellprice).toFixed(2);
        this.sellBtnChange();
      }
    },
    sellhalfClick() {
      if (this.sellable >= 100) {
        this.sellsum = parseInt(this.sellable / 2 / 100) * 100;
        if (this.sellsum < 100) {
          this.sellsum = 100;
        }
        this.sellAmount = (this.sellsum * this.sellprice).toFixed(2);
        this.sellBtnChange();
      }
    },
    sellthirdClick() {
      if (this.sellable >= 100) {
        this.sellsum = parseInt(this.sellable / 3 / 100) * 100;
        if (this.sellsum < 100) {
          this.sellsum = 100;
        }
        this.sellAmount = (this.sellsum * this.sellprice).toFixed(2);
        this.sellBtnChange();
      }
    },
    sellquarterClick() {
      if (this.sellable >= 100) {
        this.sellsum = parseInt(this.sellable / 4 / 100) * 100;
        if (this.sellsum < 100) {
          this.sellsum = 100;
        }
        this.sellAmount = (this.sellsum * this.sellprice).toFixed(2);
        this.sellBtnChange();
      }
    },
    sellCodeIput() {
      // 搜索框
      if (this.sellStkCode != "") {
        this.getSearchstock(this.sellStkCode, 1);
      } else if (this.sellStkCode == "") {
        this.show = false;
        this.sList = [];
        this.sellInfo = {};
        this.sellprice = "";
        this.sellStkName = "";
        this.sellable = 0;
        this.sellsum = "";
        this.sellAmount = "";
        this.sellCode = "";
      }
    },
    sellPriceIput() {
      this.sellAmount = (this.sellsum * this.sellprice).toFixed(2);
      this.sellBtnChange();
    },
    sellsumIput() {
      console.log(this.sellsum);
      this.sellAmount = (this.sellsum * this.sellprice).toFixed(2);
      this.sellBtnChange();
    },
    sellReal(stockCode) {
      let params = { prodCode: stockCode };
      zfxfApi.getStockReal(params).then((res) => {
        // console.log(res);
        if (res.code == 0) {
          var data = res.data[Object.keys(res.data)[0]];
          data.sellVolume1 = changeBillionToCN(data.sellVolume1);
          data.sellVolume2 = changeBillionToCN(data.sellVolume2);
          data.sellVolume3 = changeBillionToCN(data.sellVolume3);
          data.sellVolume4 = changeBillionToCN(data.sellVolume4);
          data.sellVolume5 = changeBillionToCN(data.sellVolume5);
          data.buyVolume1 = changeBillionToCN(data.buyVolume1);
          data.buyVolume2 = changeBillionToCN(data.buyVolume2);
          data.buyVolume3 = changeBillionToCN(data.buyVolume3);
          data.buyVolume4 = changeBillionToCN(data.buyVolume4);
          data.buyVolume5 = changeBillionToCN(data.buyVolume5);
          // console.log(data);
          this.sellInfo = data;
          // this.buyStkCode = stockCode;
          this.sellStkName = this.sellInfo.prod_name;
          if (this.sellInfo.buyPrice1 != 0) {
            this.sellprice = this.sellInfo.buyPrice1;
          } else {
            this.sellprice = this.sellInfo.sellPrice1;
          }
          for (let i = 0; i < this.stockList.length; i++) {
            console.log(this.stockList[i].stkCode, this.sellStkCode);
            if (this.sellStkCode == this.stockList[i].stkCode) {
              this.sellable = this.stockList[i].stkBalanceSum;
            }
          }
          this.show = false;
        } else if (res.code == 401) {
          setTimeout(() => {
            this.sellReal(stockCode);
          }, 500);
        }
      });
    },
    sellClick() {
      this.btnMsg = {
        price: this.sellprice,
        StkCode: this.sellStkCode,
        StkName: this.sellStkName,
        sum: this.sellsum,
        market: this.sellmarket,
        Type: 2,
        name: "卖出",
      };
      this.Btnshow = true;
    },
    // 路由切换
    onClick(name, title) {
      this.show = false;
      this.$router.replace({ path: "/deal?id=" + this.active });
    },
    goJRCJ() {
      this.$router.push({ path: "/jrcj" });
    },
    goJRWT() {
      this.$router.push({ path: "/jrwt" });
    },
    goLSCJ() {
      this.$router.push({ path: "/lscj" });
    },
    goLSWT() {
      this.$router.push({ path: "/lswt" });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  height: 100vh;
  // overflow: hidden;
  background: #f5f5f5;
  padding-top: 0.87rem;
}

.list {
  padding-top: 0.08rem;

  li {
    height: 1rem;
    background: #fff;
    padding: 0 0.32rem;
    font-size: 0.32rem;
    font-weight: 500;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.02rem solid rgba(237, 237, 237, 0.8);

    img {
      width: 0.48rem;
      height: 0.48rem;
    }
  }

  li:nth-child(2) {
    border-bottom: 0.2rem solid rgba(245, 245, 245, 1);
  }
}

.main {
  padding: 0 0.32rem;
  height: 5.8rem;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    height: 5rem;
    width: 3.7rem;

    // background: #ccc;
    .stockIpt {
      height: 0.44rem;
      width: 3.7rem;
      padding-bottom: 0.04rem;
      border-bottom: 1px solid rgba(186, 192, 202, 1);
      display: flex;
      // justify-content: space-between;
      align-items: center;
      font-size: 0.28rem;
      position: relative;

      img {
        width: 0.34rem;
        height: 0.34rem;
      }

      input {
        border: 0;
        width: 2.1rem;
        padding-left: 0.1rem;
      }

      input::-webkit-input-placeholder {
        font-size: 0.28rem;
        color: #a2a5ac;
      }

      span {
        position: absolute;
        right: 0;
        min-width: 1.5rem;
        text-align: right;
      }
    }

    .stockPrice {
      margin-top: 0.42rem;
    }

    .stockInterval {
      height: 0.64rem;
      padding-bottom: 0.04rem;
      font-size: 0.24rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      div:nth-child(1) {
        color: #1aaa52;
      }

      div:nth-child(2) {
        color: #ec333b;
      }

      p {
        color: #48546a;
      }
    }

    .stockAdd {
      height: 0.62rem;
      display: flex;
      justify-content: space-between;

      input {
        border: 0;
        width: 2.3rem;
        height: 100%;
        text-align: center;
        // border-bottom: 1px solid rgba(186, 192, 202, 1);
      }

      .ipt {
        width: 2.3rem;
        height: 100%;
        border-bottom: 1px solid rgba(186, 192, 202, 1);
      }

      .jian {
        width: 0.62rem;
        height: 0.62rem;
        display: flex;
        justify-content: center;
        align-items: center;

        border-radius: 0.04rem;
        background: #6b6a84;

        p {
          width: 0.24rem;
          height: 0.04rem;
          background: #fff;
        }
      }

      .add {
        width: 0.62rem;
        height: 0.62rem;
        font-size: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        border-radius: 0.04rem;
        background: #ec333b;
      }

      .selladd {
        width: 0.62rem;
        height: 0.62rem;
        font-size: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        border-radius: 0.04rem;

        background: #3283ea;
      }
    }

    .stockList {
      display: flex;
      justify-content: space-between;

      /deep/.van-tag {
        font-size: 0.24rem;
      }
    }
  }

  .right {
    height: 5rem;
    width: 2.8rem;
  }
}

.van-button {
  margin-top: 0.32rem;
  width: 100%;
  height: 0.76rem;
  border: 0;
  line-height: 0.76rem;
}

.buyAmount {
  // width: 2rem;
  padding: 0 0.1rem;
  height: 0.4rem;
  background: #ec333b;
  color: #fff !important;
  font-size: 0.28rem;
  line-height: 0.4rem;
  text-align: center;
}

.sellAmount {
  // width: 2rem;
  padding: 0 0.1rem;
  height: 0.4rem;
  background: #3283ea;
  color: #fff !important;
  font-size: 0.28rem;
  line-height: 0.4rem;
  text-align: center;
}

/deep/.van-cell {
  padding: 0 0 0 0.1rem;
  width: 2.2rem;
}

.StockCodeList {
  .wrapper {
    display: flex;
    // align-items: center;
    // justify-content: center;
    height: 100%;
    // margin-top: 40%;
  }

  .van-overlay {
    margin-top: 40%;
    height: 100%;
    background-color: #fff;
  }

  .block {
    width: 100%;
    height: 10rem;
    padding: 0 0.32rem;
    // border-top: 1px solid #ededed;
    background-color: #fff;
    z-index: 10000;
    overflow: hidden;

    div {
      height: 7rem;
      overflow: auto;
      z-index: 10000;
    }

    p {
      height: 0.6rem;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #ededed;
      color: #3283ea;

      span {
        width: 33%;
      }

      span:nth-child(2) {
        text-align: center;
      }

      span:nth-child(3) {
        text-align: right;
      }
    }

    p:last-child {
      margin-bottom: 0.5rem;
    }
  }
}

.Btnshow {
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 4.4rem;
    height: 4.3rem;
    border-radius: 0.04rem;
    background-color: #fff;

    .btn-title {
      height: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.32rem;
    }

    .btn-info {
      height: 1.2rem;
      padding: 0.2rem;

      p {
        width: 50%;
        height: 50%;
        float: left;
        margin-bottom: 0.2rem;
        font-size: 0.28rem;
        display: flex;
        align-items: center;

        span {
          display: flex;
          align-items: center;
        }

        span:nth-child(1) {
          padding-right: 0.2rem;
          font-size: 0.28rem;
          color: #666;
        }
      }
    }

    .btn {
      width: 100%;
      height: 0.8rem;
      background: #fff;
      margin-top: 0.3rem;
      border-radius: 0.04rem;
      display: flex;
      border-top: 1px solid #ededed;

      div {
        width: 50%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .btn-left {
        border-right: 1px solid #ededed;
      }
    }
  }
}

.wushuju {
  height: 4rem;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;

  // padding-top: 0.2rem;
  img {
    height: 4rem;
    width: 4rem;
  }
}

.main-centent {
  padding: 0 0 0 0.32rem;
  background: #fff;
  border-bottom: 0.01rem solid rgba(237, 237, 237, 1);
}

.todaySelected-top {
  height: 0.5rem;
  font-size: 0.36rem;
  font-weight: bold;
  color: #333333;
  line-height: 0.5rem;
}

.todaySelected-title {
  height: 0.76rem;
  color: #666666;
  //   margin: 0 0 0 0.32rem;
  font-size: 0.24rem;

  display: flex;
  justify-content: initial;
  align-items: center;

  div:nth-child(4) {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    img {
      width: 0.44rem;
      height: 0.44rem;
    }
  }
}

input {
  border-radius: 0 im !important;
}
</style>